import { apiService } from "api/apiService";
import {
  studentMeetingEditFromDto,
  studentMeetingFormDataToDto,
} from "meetings/student-meeting/api/mappers";
import type {
  StudentMeetingEdit,
  StudentMeetingEditDto,
  StudentMeetingFormData,
} from "meetings/student-meeting/types";

export const storeStudentMeeting = async (
  form: StudentMeetingFormData,
): Promise<void> => {
  await apiService.post("api/meetings", studentMeetingFormDataToDto(form));
};

export const fetchStudentMeetingForEdit = async (
  meetingId: number,
): Promise<StudentMeetingEdit> => {
  const { data } = await apiService.get<StudentMeetingEditDto>(
    `api/meetings/${meetingId}/edit`,
  );
  return studentMeetingEditFromDto(data);
};

export const updateStudentMeeting = async (
  meetingId: number,
  form: StudentMeetingFormData,
): Promise<void> => {
  await apiService.put(
    `api/meetings/${meetingId}`,
    studentMeetingFormDataToDto(form),
  );
};
